import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-cbd73ba4")

_pushScopeId("data-v-cbd73ba4")
const _hoisted_1 = {
  key: 0,
  style: {"width":"100%","height":"30px"}
}
const _hoisted_2 = {
  key: 1,
  class: "top-button-group flex alginC"
}
const _hoisted_3 = { class: "mar-t-12 mar-l-16" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新建B单", -1)
const _hoisted_5 = { class: "mar-t-12 mar-l-16" }
const _hoisted_6 = { class: "mar-t-12" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "合作方", -1)
const _hoisted_8 = { class: "mar-t-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "服务类型", -1)
const _hoisted_10 = { class: "mar-t-12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "单位", -1)
const _hoisted_12 = { class: "mar-t-12" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "接车人", -1)
const _hoisted_14 = { class: "mar-t-12" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "结算方式", -1)
const _hoisted_16 = { class: "mar-t-12" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "mar-l-16" }, "车型", -1)
const _hoisted_18 = { class: "mar-t-12 mar-l-16" }
const _hoisted_19 = { class: "flex flexC" }
const _hoisted_20 = {
  key: 0,
  class: "view-cirle"
}
const _hoisted_21 = { class: "flex flexC alignC" }
const _hoisted_22 = {
  id: "printBtn",
  style: {"display":"none"}
}
const _hoisted_23 = { class: "flex flexR mar-t-22" }
const _hoisted_24 = { style: {"width":"430px","margin":"0 auto"} }
const _hoisted_25 = { class: "padding-tb-20 flex flexC alignC bg-f4" }
const _hoisted_26 = { class: "mar-l-16" }
const _hoisted_27 = { class: "mar-l-16" }
const _hoisted_28 = { class: "flex flexSb mar-t-30" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", null, "报价金额", -1)
const _hoisted_30 = { class: "flex flexSb mar-t-30 alignC" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 直接减免 ")
const _hoisted_32 = {
  key: 0,
  class: "flex flexSb mar-t-30"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, "工单预收抵扣", -1)
const _hoisted_34 = {
  key: 1,
  class: "flex flexSb mar-t-30"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", null, "工单预收退款：(将自动生成预收退款应付)", -1)
const _hoisted_36 = {
  key: 2,
  class: "flex flexSb mar-t-30"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", null, "工单预收退款：(将自动生成预收退款应付)", -1)
const _hoisted_38 = {
  key: 3,
  class: "flex flexSb mar-t-30 alignC"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("余额抵扣 ")
const _hoisted_40 = {
  key: 4,
  class: "flex flexSb mar-t-30"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", null, "会员剩余门店余额", -1)
const _hoisted_42 = {
  key: 5,
  class: "flex flexSb mar-t-30"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", null, "结算金额", -1)
const _hoisted_44 = { class: "c-red" }
const _hoisted_45 = {
  key: 6,
  class: "flex flexSb mar-t-30"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, "应收金额", -1)
const _hoisted_47 = { class: "c-red" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("挂帐")
const _hoisted_50 = { class: "mar-l-12 c-99" }
const _hoisted_51 = { class: "dialog-footer" }
const _hoisted_52 = { class: "c-ff" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "取 消", -1)
const _hoisted_54 = { style: {"width":"430px","margin":"0 auto"} }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", null, "元", -1)
const _hoisted_56 = { class: "dialog-footer" }
const _hoisted_57 = { class: "c-ff" }
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, "取 消", -1)
const _hoisted_59 = { class: "flex flexR" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "打印报价单", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "车辆信息", -1)
const _hoisted_62 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_63 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_64 = { class: "flex" }
const _hoisted_65 = { class: "dialog-footer" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_68 = { class: "print" }
const _hoisted_69 = { class: "header" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_71 = { class: "store_name" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "title flex-1" }, " 车辆维修工时配件结算单 ", -1)
const _hoisted_73 = { class: "body" }
const _hoisted_74 = { class: "order-head flex alignC" }
const _hoisted_75 = { class: "ordersn flex-1" }
const _hoisted_76 = { class: "time" }
const _hoisted_77 = { class: "order-info" }
const _hoisted_78 = /*#__PURE__*/_createVNode("th", null, "车牌号码：", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("th", null, "车型：", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("th", null, "车架号：", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("th", null, "送修人；", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("th", null, "联系电话：", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("th", null, "服务类型：", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("th", null, "进厂时间：", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("th", null, "进厂里程：", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("th", null, "接车人：", -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("th", null, "出厂时间：", -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("th", null, "下次保养：", -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("th", null, "下次保养里程：", -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("th", null, "送修单位：", -1)
const _hoisted_91 = {
  key: 0,
  class: "project-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "维修项目"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_94 = {
  colspan: "4",
  class: "count"
}
const _hoisted_95 = {
  key: 1,
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "配件名称"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_97 = {
  colspan: "5",
  class: "count"
}
const _hoisted_98 = {
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "报价金额"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "优惠券"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "余额抵扣"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "其他优惠"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "合计优惠"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "结算金额")
  ])
], -1)
const _hoisted_100 = { key: 0 }
const _hoisted_101 = {
  colspan: "6",
  class: "total"
}
const _hoisted_102 = { class: "other" }
const _hoisted_103 = { class: "info" }
const _hoisted_104 = { class: "item" }
const _hoisted_105 = { class: "item" }
const _hoisted_106 = { class: "item" }
const _hoisted_107 = {
  key: 0,
  class: "store mar-r-30"
}
const _hoisted_108 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 扫码关注公众号 ", -1)
const _hoisted_109 = { class: "qrcode" }
const _hoisted_110 = {
  key: 1,
  class: "store"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 微信扫码支付 ", -1)
const _hoisted_112 = { class: "qrcode" }
const _hoisted_113 = { class: "footer" }
const _hoisted_114 = { class: "address" }
const _hoisted_115 = { class: "telphone" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_PrintForm = _resolveComponent("PrintForm")
  const _directive_loading = _resolveDirective("loading")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "bg-ff table-content",
      style: _ctx.isPrint?'padding-bottom: 180px;':''
    }, [
      (!_ctx.selectList)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, "加载中", 512)), [
            [_directive_loading]
          ])
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                class: "mar-l-9 bg-red",
                onClick: _ctx.createOrder
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                class: "width-114",
                modelValue: _ctx.screenParameter.date_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date_type = $event)),
                clearable: "",
                placeholder: "请选择"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "开单时间",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "结算时间",
                    value: "2"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_date_picker, {
                class: "mar-l-8",
                disabled: !_ctx.screenParameter.date_type,
                type: "daterange",
                modelValue: _ctx.screenParameter.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.date = $event)),
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束时间",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenChange($event, 'date')))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.partner_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.partner_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.partner_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.basicset_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.basicset_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                placeholder: "请选择",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.project_type_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      value: item.basicset_id,
                      label: item.basicset_name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.units_id,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.units_id = $event)),
                class: "width-114 mar-l-8",
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.unitList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.repair_unit_id,
                      label: item.repair_unit_name,
                      value: item.repair_unit_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.meet_vehicle_id,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.screenParameter.meet_vehicle_id = $event)),
                class: "width-100 mar-l-8",
                clearable: "",
                placeholder: "请选择",
                filterable: "",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staffList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.nickname,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_select, {
                modelValue: _ctx.screenParameter.settlement_type,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.screenParameter.settlement_type = $event)),
                placeholder: "请选择",
                clearable: "",
                class: "mar-l-8",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.screenChange($event, 'select'))),
                style: {"width":"154px"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payTypeArray.zf, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.basicset_name,
                      value: item.basicset_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_select, {
                class: "width-100 mar-l-8",
                modelValue: _ctx.screenParameter.car_brand_id,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.screenParameter.car_brand_id = $event)),
                clearable: "",
                filterable: "",
                placeholder: "请选择",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.screenChange($event, 'select_brand')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.carbrandList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.brand_name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                class: "width-114 mar-l-8",
                modelValue: _ctx.screenParameter.car_series_id,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.screenParameter.car_series_id = $event)),
                disabled: !_ctx.screenParameter.car_brand_id,
                clearable: "",
                placeholder: "请选择",
                filterable: "",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.screenChange($event, 'select')))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.carseriesList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.series_name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_el_input, {
                style: {"width":"230px"},
                modelValue: _ctx.screenParameter.search,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.screenParameter.search = $event)),
                placeholder: "单据编号/车牌/送修人/手机号",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.screenChange($event, 'search'))),
                "suffix-icon": "el-icon-search"
              }, null, 8, ["modelValue"])
            ])
          ])),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "单据编号",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", {
                  class: "c-red ordersn",
                  onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row.order_id))
                }, _toDisplayString(scope.row.ordersn), 9, ["onClick"]),
                (scope.row.is_pre==1)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, " 预 "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_21, [
                _createVNode("div", {
                  class: "btn-red",
                  onClick: ($event: any) => (_ctx.columnChange(scope.row,1))
                }, "修改", 8, ["onClick"]),
                _createVNode("div", {
                  class: "btn-red mar-l-2",
                  onClick: ($event: any) => (_ctx.columnChange(scope.row,2))
                }, " 修改收款金额 ", 8, ["onClick"]),
                _createVNode("div", {
                  class: "btn-red mar-l-2 mar-t-10",
                  onClick: ($event: any) => (_ctx.columnChange(scope.row,3))
                }, " 修改信息 ", 8, ["onClick"]),
                _createVNode("div", {
                  onClick: ($event: any) => (_ctx.bindPrint(scope.row.order_id)),
                  class: "btn-red mar-l-2 mar-t-10"
                }, "打印 ", 8, ["onClick"]),
                _withDirectives(_createVNode("div", _hoisted_22, null, 512), [
                  [_directive_print, _ctx.printData]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_el_pagination, {
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.currentPage,
          "page-sizes": [10, 20,50,100],
          "page-size": _ctx.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
      ]),
      _createVNode(_component_el_dialog, {
        title: _ctx.dialog_title,
        modelValue: _ctx.dialog_show,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialog_show = $event)),
        center: "",
        width: 1000
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_51, [
            _createVNode(_component_el_button, {
              class: "bg-red",
              onClick: _ctx._submitForm
            }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_52, _toDisplayString(_ctx.dialog_title == '结算' ? '结算' : '确认'), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.dialog_show = false))
            }, {
              default: _withId(() => [
                _hoisted_53
              ]),
              _: 1
            })
          ])
        ]),
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", null, "车牌号码：" + _toDisplayString(_ctx.form.order_crd_code_text), 1),
              _createVNode("div", _hoisted_26, "会员号：" + _toDisplayString(_ctx.form.user_id), 1),
              _createVNode("div", _hoisted_27, "会员门店余额：" + _toDisplayString(_ctx.form.user_store_balance), 1)
            ]),
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.order_offer_price), 1)
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("div", null, [
                _hoisted_31,
                (_ctx.dialog_title != '结算')
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      class: "width-82 mar-l-2",
                      type: "number",
                      modelValue: _ctx.form.discount_price,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.discount_price = $event)),
                      max: _ctx.form.order_offer_price,
                      min: "0",
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.reductionChange($event))),
                      onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.reductionChange($event)))
                    }, null, 8, ["modelValue", "max"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.discount_price), 1)
            ]),
            (_ctx.form.order_advance_payment_text>0)
              ? (_openBlock(), _createBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.order_advance_payment_text), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.refund_price>0 && _ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.refund_price), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title == '结算' && _ctx.form.is_advance==1)
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.advance_price), 1)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.form.order_offer_price - _ctx.form.discount_price-_ctx.form.order_advance_payment_text) > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_38, [
                  _createVNode("div", null, [
                    _hoisted_39,
                    (_ctx.form.user_store_balance > 0 && _ctx.dialog_title != '结算')
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          class: "width-82 mar-l-2",
                          type: "number",
                          modelValue: _ctx.form.use_balance,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.use_balance = $event)),
                          max: _ctx.form.user_store_balance,
                          min: "0",
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.balanceChange($event))),
                          onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.balanceChange($event)))
                        }, null, 8, ["modelValue", "max"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, "-¥" + _toDisplayString(_ctx.form.use_balance), 1)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.form.order_offer_price - _ctx.form.discount_price-_ctx.form.order_advance_payment_text) > 0 && _ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode("div", null, "¥" + _toDisplayString(_ctx.form.user_store_balance-_ctx.form.use_balance), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title != '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode("div", _hoisted_44, "¥" + _toDisplayString(_ctx.form.price), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog_title == '结算')
              ? (_openBlock(), _createBlock("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode("div", _hoisted_47, "¥" + _toDisplayString(_ctx.form.price), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form, {
              class: "mar-t-20",
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.form_rules
            }, {
              default: _withId(() => [
                (_ctx.dialog_title == '结算')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "收款方式",
                      required: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "settlement_type" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  placeholder: "请选择",
                                  clearable: "",
                                  modelValue: _ctx.form.settlement_type,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.settlement_type = $event)),
                                  disabled: _ctx.form.is_hang_,
                                  style: {"width":"142px"}
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.collection, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { prop: "price" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  class: "mar-l-8 mar-r-8",
                                  style: {"width":"101px"},
                                  min: "0",
                                  modelValue: _ctx.form.payment_price,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.payment_price = $event)),
                                  disabled: _ctx.form.is_hang_
                                }, null, 8, ["modelValue", "disabled"]),
                                _hoisted_48,
                                _createVNode(_component_el_checkbox, {
                                  class: "mar-l-24",
                                  modelValue: _ctx.form.is_hang_,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.is_hang_ = $event))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_49
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "工单备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.settlement_notes,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.settlement_notes = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "请输入内容"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "打印备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.printing_desc,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.printing_desc = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "请输入内容"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.dialog_title != '结算')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "结算类别"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.settleData.settlement_class,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.settleData.settlement_class = $event)),
                          class: "width-100",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementType, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.type_name,
                                value: item.type_id,
                                key: item.type_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode("label", _hoisted_50, _toDisplayString(_ctx.settlementType[_ctx.settleData.settlement_class].type_desc), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ], 512), [
            [_directive_loading, _ctx.form_load]
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_el_dialog, {
        title: _ctx.settle_title,
        modelValue: _ctx.settle_show,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.settle_show = $event)),
        center: "",
        width: 600
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_56, [
            _createVNode(_component_el_button, {
              class: "bg-red",
              onClick: _ctx._submitSettle
            }, {
              default: _withId(() => [
                _createVNode("span", _hoisted_57, _toDisplayString(_ctx.settle_title == '结算' ? '结算' : '确认'), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.settle_show = false))
            }, {
              default: _withId(() => [
                _hoisted_58
              ]),
              _: 1
            })
          ])
        ]),
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_54, [
            _createVNode(_component_el_form, {
              class: "mar-t-20",
              ref: "return_price_ref",
              model: _ctx.return_price_form_data,
              rules: _ctx.return_price_rules
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "收款方式",
                  required: ""
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { prop: "settlement_type" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              placeholder: "请选择",
                              clearable: "",
                              modelValue: _ctx.return_price_form_data.settlement_type,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.return_price_form_data.settlement_type = $event)),
                              style: {"width":"142px"}
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.collection, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { prop: "price" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "mar-l-8 mar-r-8",
                              style: {"width":"101px"},
                              modelValue: _ctx.return_price_form_data.price,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.return_price_form_data.price = $event))
                            }, null, 8, ["modelValue"]),
                            _hoisted_55
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "回款备注" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.return_price_form_data.return_price_notes,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.return_price_form_data.return_price_notes = $event)),
                      type: "textarea",
                      row: "3",
                      style: {"width":"350px"},
                      placeholder: "请输入内容"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ], 512), [
            [_directive_loading, _ctx.form_load]
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "工单详情",
        modelValue: _ctx.dialogFormVisible,
        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.dialogFormVisible = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_59, [
            _createVNode(_component_el_button, {
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.bindPrint(_ctx.currentOrder)))
            }, {
              default: _withId(() => [
                _hoisted_60
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.getCarInfo }, {
              default: _withId(() => [
                _hoisted_61
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("table", _hoisted_62, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ]),
          (_ctx.orderDetail.order_offer_project.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: _ctx.orderDetail.order_offer_project,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 1),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.order_offer_mountings.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: _ctx.orderDetail.order_offer_mountings,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 2),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.mountings_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 2,
                data: _ctx.orderDetail.mountings_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 3),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.else_cost.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 3,
                data: _ctx.orderDetail.else_cost,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "show-summary": "",
                "summary-method": (item) => _ctx.getSummaries(item, 4),
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "summary-method", "header-cell-style"]))
            : _createCommentVNode("", true),
          (_ctx.orderDetail.settlement.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 4,
                data: _ctx.orderDetail.settlement,
                stripe: "",
                style: {"width":"100%"},
                class: "mar-b-10",
                "header-cell-style": _ctx.headClass
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "header-cell-style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        title: "车辆信息",
        modelValue: _ctx.carInfoDia_show,
        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.carInfoDia_show = $event)),
        onClosed: _ctx.handleClose,
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("table", _hoisted_63, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carInfoTable, (items, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                  return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"]),
      _createVNode(_component_el_dialog, {
        title: "新增",
        modelValue: _ctx.fadeDia_show,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.fadeDia_show = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            type: "text",
            "prefix-icon": "el-icon-search",
            style: {"width":"180px"},
            placeholder: "输入车牌号码搜索",
            modelValue: _ctx.dialog_search,
            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.dialog_search = $event)),
            onChange: _ctx.get_dialog_data
          }, null, 8, ["modelValue", "onChange"]),
          _withDirectives(_createVNode(_component_el_table, {
            class: "mar-t-10",
            data: _ctx.dialog_data,
            stripe: "",
            border: "",
            style: {"width":"100%"},
            "max-height": "350",
            onCurrentChange: _ctx._table_select_carcode,
            "header-cell-style": "{background-color: #f2f5f9, height: 48px, text-align: center}"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "ordersn",
                label: "单据编号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "car_code",
                label: "车牌号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "category_name",
                label: "车辆型号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "meet_vehicle",
                label: "接车人",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "create_time_text",
                label: "开单时间",
                "min-width": 84
              })
            ]),
            _: 1
          }, 8, ["data", "onCurrentChange"]), [
            [_directive_loading, _ctx.dialog_isload]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "编辑",
        modelValue: _ctx.editCarData.dialog_show,
        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.editCarData.dialog_show = $event)),
        center: "",
        width: 1000
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_65, [
            _createVNode(_component_el_button, {
              class: "bg-red",
              onClick: _ctx.saveSubmit
            }, {
              default: _withId(() => [
                _hoisted_66
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.editCarData.dialog_show = false))
            }, {
              default: _withId(() => [
                _hoisted_67
              ]),
              _: 1
            })
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_el_form, {
            ref: _ctx.editCarData.formRef,
            model: _ctx.editCarData.form,
            rules: _ctx.editCarData.rules,
            "label-width": "100px"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_64, [
                _createVNode(_component_el_form_item, { label: "开单日期" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-wid",
                      modelValue: _ctx.editCarData.form.create_time_text,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.editCarData.form.create_time_text = $event)),
                      placeholder: "请选择开单日期",
                      onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.saveCarInfoChange($event,'create_time')))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "结算日期" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-wid",
                      modelValue: _ctx.editCarData.form.settlement_time_text,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.editCarData.form.settlement_time_text = $event)),
                      placeholder: "请选择结算日期",
                      onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.saveCarInfoChange($event,'settlement_time')))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    _withDirectives(_createVNode(_component_PrintForm, { id: "print" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _hoisted_70,
            _createVNode("div", _hoisted_71, _toDisplayString(_ctx.orderDetail.store_name), 1),
            _hoisted_72
          ]),
          _createVNode("div", _hoisted_73, [
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, " 单据编号：" + _toDisplayString(_ctx.orderDetail.ordersn), 1),
              _createVNode("div", _hoisted_76, _toDisplayString(_ctx.orderDetail.create_time_text), 1)
            ]),
            _createVNode("table", _hoisted_77, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_78,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.car_code), 1),
                  _hoisted_79,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.series_name), 1),
                  _hoisted_80,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.vin), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_81,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair), 1),
                  _hoisted_82,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.send_for_repair_phone), 1),
                  _hoisted_83,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.basicset_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_84,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.create_time_text), 1),
                  _hoisted_85,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.mitplant), 1),
                  _hoisted_86,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_87,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.delivery_time_text), 1),
                  _hoisted_88,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.next_maintain), 1),
                  _hoisted_89,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.next_maintain_mileage), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_90,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail.units_id_name), 1)
                ])
              ])
            ]),
            (_ctx.isProject)
              ? (_openBlock(), _createBlock("table", _hoisted_91, [
                  _hoisted_92,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_project, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.project_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _hoisted_93,
                      _createVNode("th", _hoisted_94, "维修工时费小计：￥" + _toDisplayString(_ctx.orderDetail?.project_sum_quoted_price || 0), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isMountings)
              ? (_openBlock(), _createBlock("table", _hoisted_95, [
                  _hoisted_96,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.order_offer_mountings, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.mountings_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_97, "配件费用小计：￥" + _toDisplayString(_ctx.orderDetail?.mountings_sum_quoted_price || 0), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("table", _hoisted_98, [
              _hoisted_99,
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.offer_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.coin_voucher || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.other_coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.total_coupon_price || 0), 1),
                  _createVNode("th", null, "￥" + _toDisplayString(_ctx.orderDetail?.settlement_price || 0), 1)
                ]),
                (_ctx.orderDetail.cash_back_price)
                  ? (_openBlock(), _createBlock("tr", _hoisted_100, [
                      _createVNode("th", _hoisted_101, " 会员号：" + _toDisplayString(_ctx.orderDetail.user_id) + " 本次消费返现：￥" + _toDisplayString(_ctx.orderDetail.cash_back_price), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_102, [
              _createVNode("div", _hoisted_103, [
                _createVNode("div", _hoisted_104, " 客　户：" + _toDisplayString(_ctx.orderDetail.user_name), 1),
                _createVNode("div", _hoisted_105, " 接车员：" + _toDisplayString(_ctx.orderDetail.meet_vehicle_id_name), 1),
                _createVNode("div", _hoisted_106, " 出纳：" + _toDisplayString(_ctx.orderDetail.cashier_name), 1)
              ]),
              (_ctx.publicImgeUrl)
                ? (_openBlock(), _createBlock("div", _hoisted_107, [
                    _hoisted_108,
                    _createVNode("div", _hoisted_109, [
                      _createVNode("img", {
                        src: _ctx.publicImgeUrl,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.qrcodeImgeUrl&&_ctx.orderDetail.orderstatus==4)
                ? (_openBlock(), _createBlock("div", _hoisted_110, [
                    _hoisted_111,
                    _createVNode("div", _hoisted_112, [
                      _createVNode("img", {
                        src: _ctx.qrcodeImgeUrl,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_113, [
              _createVNode("div", _hoisted_114, " 地址：" + _toDisplayString(_ctx.orderDetail.address), 1),
              _createVNode("div", _hoisted_115, " 电话：" + _toDisplayString(_ctx.orderDetail.service_phone), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isPrint]
    ])
  ], 64))
})